import useAPI from '@/hooks/useAPI';
import WorkRepository from '@/repositories/WorkRepository';
import type { Taskable } from '@/types/taskable';

const contentTypeModel = ({ contentTypeName }: Taskable) =>
  contentTypeName.includes('.') ? contentTypeName.split('.')[1] : contentTypeName;

const useCompactTaskList = ({
  personId,
  taskables
}: {
  personId: string;
  taskables?: Taskable[];
}) => {
  const workRepo = WorkRepository();

  return useAPI({
    // Shares the getPersonTasks namespace so a task closed elsewhere refreshes this list.
    queryKey: ['getPersonTasks', personId, { compact: true, taskables }],
    queryFn: async () =>
      workRepo.getItems({
        // Taskables fully scope the request; person_id would additionally require an
        // encounter-attached task to carry the person FK.
        personId: taskables?.length ? undefined : personId,
        taskableId: taskables?.map(({ id }) => id),
        taskableTypeModel: taskables?.map(contentTypeModel),
        params: {
          status: ['open', 'in_progress'],
          ordering: 'due_or_created_at',
          page: '1'
        }
      })
  });
};

export default useCompactTaskList;
